import { generatePath } from 'react-router';

import { PATHS } from '@/shared/config';

import {
  RECORDING_START_SCHEMA_PARAM,
  RECORDING_START_SERIES_PARAM,
} from '../config';

type ConsultationPathParams = {
  patientID: string;
  consultationID: string;
};

export const getConsultationPath = ({
  patientID,
  consultationID,
}: ConsultationPathParams): string =>
  `${generatePath(PATHS.consultation, { patientID })}?tab=summary&id=${consultationID}`;

export const getRecordingsPath = (patientID: string): string =>
  generatePath(PATHS.patientRecordings, { patientID });

export const getRecordingPath = ({
  patientID,
  recordingID,
}: {
  patientID: string;
  recordingID: string;
}): string =>
  generatePath(PATHS.patientRecording, { patientID, recordId: recordingID });

export const getRecordingStartPath = ({
  patientID,
  seriesId,
  schemaId,
}: {
  patientID: string;
  seriesId?: string;
  schemaId: string;
}): string =>
  `${generatePath(PATHS.patientRecordingStart, { patientID })}?${new URLSearchParams(
    seriesId
      ? { [RECORDING_START_SERIES_PARAM]: seriesId }
      : { [RECORDING_START_SCHEMA_PARAM]: schemaId },
  )}`;

export const getEncounterPath = ({
  patientID,
  consultation,
}: {
  patientID: string;
  consultation: { id: string; transcriptorV2?: boolean };
}): string =>
  consultation.transcriptorV2
    ? getRecordingPath({ patientID, recordingID: consultation.id })
    : getConsultationPath({ patientID, consultationID: consultation.id });
